<template>
    <div class="card">
      <div class="card-header bg-article pt-5 text-white">
         <h3 class="card-category"><b>DEBATE</b></h3>
    </div>
    <div class="card-description pt-3">
        <div class="row">
            <div class="col-sm-12">
         <h4 class="p-2">
           <strong>Topic : </strong> {{debate.topic}}
            </h4>
            <div class="d-flex">
                <p class="p-3 text-justify">
                        {{debate.body.split('.')[0]}} {{debate.body.slice(0,300)}}
                        <router-link class="text-danger" :to="`debatedetails/${debate.id}`">Read more...</router-link>
                </p>
            </div>
            </div>
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-12 ">
                        <div class="d-flex justify-content-between">
                             <p class="p-3" v-if="!author"><small><strong>Created On: </strong></small> {{debate.created_by[0].first_name}} {{debate.created_by[0].last_name}} {{debate.created_by[0].other_names}}</p>
                             <p  class="p-3"  v-if="!author"><strong>Created By:</strong> {{debate.created_at | moment}}</p>
                             <p class="p-3" v-if="author"><strong>Created By:</strong>{{author.author}}</p>
                             <p class="p-3" v-if="author"><strong>Created On:</strong>{{author.date}}</p>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <button class="mx-3" v-if="debate.thesis.length == 0" @click="addLeadOpinion(debate.id)">ADD LEAD OPINION</button>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div v-if="debate.thesis.length  > 0">
            <div class="row mx-2" v-for="(thesis, key) in debate.thesis" :key="key">
            <div class="col-sm-12" >
                <h6 class="text-danger"><b>LEADER's VISION (THESIS)</b></h6>
            </div>
                <div class="col-sm-12">
                     <p class="mb-0">{{thesis.text.slice(0,300)}} <router-link :to="`/debate/${thesis.debate_article_id}/lead-opinion`" class="text-danger">Read more...</router-link></p>
                     <div class="d-flex">
                        <a class="p-2" v-if="thesis.pdf" :href="`${url()}${thesis.pdf}`" target="_blank" download>pdf</a>
                        <a  class="p-2" v-if="thesis.doc" :href="`${url()}${thesis.doc}`" target="_blank" download>document</a>
                        <a  class="p-2"  v-if="thesis.pic" :href="`${url()}${thesis.pic}`" target="_blank" download>image</a>
                        <a  class="p-2" v-if="thesis.video" :href="`${thesis.video}`" target="_blank" >Youtube</a>
                    </div>
                     <div class="row">
                         <div class="col-sm-6">
                           <p><strong> Created By</strong> {{thesis.created_by.first_name}} {{thesis.created_by.last_name}}</p>
                         </div>
                         <div class="col-sm-6">
                            <strong>Created On</strong> {{thesis.created_at | moment}}
                         </div>
                     </div>
                </div>
                <div class="col-12 py-3">
                     <button  @click="addCritique(thesis.debate_article_id, thesis.id)" v-if="thesis.antithesis && thesis.antithesis.length == 0">ADD CRETIQUE</button>
                </div>
                <hr>
            <div class="col-12" v-if="thesis.antithesis">
                <hr>
                <div class="row"  v-for="(antithesis, key) in thesis.antithesis" :key="key">
                 <div class="col-sm-12" >
                     <h6 class="text-success"><b>CRITIQUE (ANTI-THESIS)</b></h6>
                </div>
                <div class="col-sm-12">
                     <p class="mb-0">{{antithesis.text.slice(0,300)}} <router-link  :to="`/debate/${antithesis.debate_article_id}/critique`" class="text-danger">Read more...</router-link></p>
                     <div class="d-flex">
                        <a class="p-2" v-if="antithesis.pdf" :href="`${url()}${antithesis.pdf}`" target="_blank" download>pdf</a>
                        <a  class="p-2" v-if="antithesis.doc" :href="`${url()}${antithesis.doc}`" target="_blank" download>document</a>
                        <a  class="p-2"  v-if="antithesis.pic" :href="`${url()}${antithesis.pic}`" target="_blank" download>image</a>
                        <a  class="p-2" v-if="antithesis.video" :href="`${antithesis.video}`" target="_blank" >Youtube</a>
                    </div>
                     <div class="row">
                         <div class="col-sm-6">
                           <p><strong> Created By</strong> {{antithesis.created_by.first_name}} {{antithesis.created_by.last_name}}</p>
                         </div>
                         <div class="col-sm-6">
                             {{antithesis.created_at | moment}}
                         </div>
                     </div>
                </div>
                <div class="col-12 py-3">
                    <button v-if="antithesis.synthesis && antithesis.synthesis.length == 0" @click="addResolution(antithesis.debate_article_id, antithesis.debate_thesis_id, antithesis.id)">ADD RESOLUTION</button>
                </div>

                <div class="col-12" v-if="antithesis.synthesis && antithesis.synthesis.length > 0">
                    <hr>
                    <div class="row" v-for="(synthesis, key) in antithesis.synthesis" :key="key">
                        <div class="col-sm-12" >
                                <h6 class="text-success"><b>RESOLUTION (SYNTHESIS)</b></h6>
                        </div>
                        <div class="col-sm-12">
                            <p class="mb-0">{{synthesis.text.slice(0,300)}} <router-link  :to="`/debate/${antithesis.debate_article_id}/resolution`" class="text-danger">Read more...</router-link></p>
                            <div class="d-flex">
                                <a class="p-2" v-if="synthesis.pdf" :href="`${url()}${synthesis.pdf}`" target="_blank" download>pdf</a>
                                <a  class="p-2" v-if="synthesis.doc" :href="`${url()}${synthesis.doc}`" target="_blank" download>document</a>
                                <a  class="p-2"  v-if="synthesis.pic" :href="`${url()}${synthesis.pic}`" target="_blank" download>image</a>
                                <a  class="p-2" v-if="synthesis.video" :href="`${synthesis.video}`" target="_blank" >Youtube</a>
                            </div>
    
                            <div class="row">
                         <div class="col-sm-6">
                           <p><strong> Created By</strong> {{synthesis.created_by.first_name}} {{synthesis.created_by.last_name}}</p>
                         </div>
                         <div class="col-sm-6">
                             {{synthesis.created_at | moment}}
                         </div>
                     </div>
                        </div>
                        <button class="m-2" @click="contributions(synthesis.debate_article_id)" style="float:right">Contributions</button>
                    </div>
                </div>
                </div>
            </div>
           
        </div>  
        <hr>
    </div>
    </div>
    </div>
       
</template>
<script>
import url from '../helpers/url'
import authors from '../helpers/debates'
import service from './../helpers/service'
import moment from 'moment'
export default {
    name:'debateCard',
    props: {
        debate:Object
    },
    data() {
        return {
            author:{}
        }
    },
    filters: {
        moment: function (date) {
            return moment(date).format('MMMM Do YYYY');
        }
        },
    methods:{
        getAuthor() {
           this.author =  authors.find(author => author.id == this.debate.id)
        },
         url() {
             return url()
         },
         addLeadOpinion(id) {
            const user = this.$session.get('entity')
          
                 if(!user) {
                window.location.replace(`/redirect?service=login`)
            }
            
            this.$router.replace(`/debate/${id}/add_lead_opinion`)
        },
        addCritique(debateID, thesisID) {
            const user = this.$session.get('entity')
            if(!user) {
                 window.location.replace(`/redirect?service=login`)
            }
            this.$router.replace(`/debate/${debateID}/add_lead_opinion/${thesisID}/add_cretique`)
        },
        addResolution(debateID,thesisID,antithesisID) {
            const user = this.$session.get('entity')
            if(!user) {
                window.location.replace(`/redirect?service=login`)
            }
            
            this.$router.replace(`/debate/${debateID}/lead_opinion/${thesisID}/critique/${antithesisID}/add_resolution`)
        },
        contributions(debateID) {
            
            this.$router.replace(`/debate/${debateID}/contributions`)
        },
        
    },
   
    created() {
       this.getAuthor()
       console.log(this.debate)
    }
}
</script>
<style scoped>
    button{
        background-color: #bb3826;
        color:#fff;
        border:1px solid #bb3826;
        padding:10px;
        transition: all 0.5s;
        outline: 0;
        font-size: .9em;
    }
    button:hover, button:active{
        background-color:#ffc106;
        color: #ad5457 ;
    }
    .bg-article{
        background: #bb3826;
    }
    .links {
        position:absolute;
        right: 1em;
        top:1em;
    }
    .links a {
        text-decoration: none;
        color:#fff;
    }
    .links a:hover,.links a:active {
        text-decoration: none;
        color:#000;
    }
</style>